import { Level1MenuItem } from "@/features";
import { MdOutlineEnergySavingsLeaf } from "react-icons/md";
import React, { ReactElement, useContext } from "react";
import { useTextDomainContext } from "@/app/providers";
import { permissionsClimate } from "@/utils";
import { RootState, useAppSelector } from "@/app/store";

const parentPath = "climate";

export const ClimateMenu = (): ReactElement => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  const hasCompanies = useAppSelector(
    (state: RootState) => state?.auth?.user?.hasCompanies,
  );

  return (
    <Level1MenuItem
      link={`/${parentPath}`}
      label={gettext("Climate")}
      icon={<MdOutlineEnergySavingsLeaf size={18} className="mx-3" />}
      codes={permissionsClimate}
      feature="climate"
      hide={!hasCompanies}
    />
  );
};
